import React from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { StyledDialogTitle } from '../styled/Dialog/StyledDialogTitle';
import { StyledDialogContent } from '../styled/Dialog/StyledDialogContent';
import PrimaryBtn from '../shared/Buttons/PrimaryButton';

const InvoiceItemsAddedDialog: React.FC<{
    open: boolean;
    productsAdded: 'all' | 'none' | 'partially';
    handleClose: () => void;
    handleGoToCart: () => void;
}> = (props) => {
    const { t } = useTranslation('invoices', {
        keyPrefix: 'INVOICE_DETAILS.PRODUCTS_ADDED_DIALOG',
    });
    const { open, handleClose, handleGoToCart, productsAdded } = props;

    const renderSwitch = () => {
        switch (productsAdded) {
            case 'all':
                return (
                    <>
                        <Typography paragraph sx={{ textAlign: 'center' }}>
                            {t('ALL_PRODUCTS_ADDED')}
                        </Typography>
                        <Alert variant="filled" severity="warning">
                            {t('DIFFERENT_PRICES')}
                        </Alert>
                    </>
                );
            case 'partially':
                return (
                    <>
                        <Typography paragraph>{t('PRODUCTS_ADDED')}</Typography>
                        <Alert variant="filled" severity="warning">
                            {t('DIFFERENT_PRICES')}
                        </Alert>
                    </>
                );
            default:
                return <Typography paragraph>{t('NO_PRODUCT')}</Typography>;
        }
    };

    const renderAddToCart = () => {
        if (productsAdded != 'none') {
            return (
                <PrimaryBtn size="small" onClick={handleGoToCart}>
                    {t('GO_TO_CART')}
                </PrimaryBtn>
            );
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth={'sm'} fullWidth>
            <StyledDialogTitle>
                {t('TITLE')}
                <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
            </StyledDialogTitle>
            <StyledDialogContent>{renderSwitch()}</StyledDialogContent>
            <DialogActions>
                <Button size="small" onClick={handleClose}>
                    {t('BACK')}
                </Button>
                {renderAddToCart()}
            </DialogActions>
        </Dialog>
    );
};

export default InvoiceItemsAddedDialog;
